import { trimObjectValues } from '@/utilz';
import type { ShipmentItrackStatusResponse } from './api';

export const normalizeShipmentItrackStatus = (
  list: ShipmentItrackStatusResponse,
): { label: string; value: string }[] => {
  if (!list) {
    return [];
  }
  return list.map((row) =>
    trimObjectValues({
      label: row.codeDesc,
      value: row.codeId,
    }),
  );
};
